export const currentUsersKeys = {
  currentUsers: params => ["currentUsers", params],
};
